import {FileSpreadsheet} from 'lucide-react';
import clsx from 'clsx';

export function FileIdBadge({fileId, className}: {fileId: string; className?: string}) {
  return (
    <div
      className={clsx(
        'inline-flex items-center gap-2 text-xs font-medium text-internal-brand-navy border border-gray-200 bg-white rounded-full py-1.5 px-3 max-w-[300px] truncate',
        className,
      )}
    >
      <FileSpreadsheet className='h-3.5 w-3.5 text-internal-brand-blue' />
      <span className='font-mono'>{fileId}</span>
    </div>
  );
}
